export default __webpack_public_path__ + "static/media/icon-close.64fb2d88.svg";